const actions = {
  SET_STATE: "bucket/SET_STATE",
  LIST: "bucket/LIST",
  GET_DATA: "bucket/GET_DATA",
  CLEAR_RANGE: "bucket/CLEAR_RANGE",
  CLEAR_LIST: "bucket/CLEAR_LIST",
  CLEAR_DATA: "bucket/CLEAR_DATA",
};

export default actions;
